var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pSearch"
  }, [_c('div', {
    staticClass: "pSearch-input"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-search"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchText,
      expression: "searchText"
    }],
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang('Search token')
    },
    domProps: {
      "value": _vm.searchText
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchText = $event.target.value;
      }, _vm.onSearchInput]
    }
  }), _vm.isPopSearch ? _c('div', {
    staticClass: "pop-search"
  }, [_c('div', {
    staticClass: "pop-search-con"
  }, [_vm.isLoading ? [_c('div', {
    staticClass: "btnLoading",
    class: _vm.isMobile && 'wap'
  })] : [_vm.searchObj ? _c('div', {
    staticClass: "pop-search-item hover",
    on: {
      "click": _vm.onSkip
    }
  }, [_c('div', {
    staticClass: "pop-search-item__img"
  }, [_c('img', {
    attrs: {
      "src": _vm.searchObj.icon,
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "pop-search-info"
  }, [_c('div', {
    staticClass: "pop-search__name"
  }, [_c('em', [_vm._v(" " + _vm._s(_vm.searchObj.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(_vm.searchObj.symbol) + ")")])]), _c('div', {
    staticClass: "pop-search__addr"
  }, [_vm._v(_vm._s(_vm.searchObj.creator))])])]) : _c('div', {
    staticClass: "pop-search-result"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-search"
    }
  }), _c('span', [_vm._v("No tokens found!")])], 1)]], 2)]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };